// ---------------------------
// AUTO-GENERATED. DO NOT EAT.
// ---------------------------
import { createEnum } from "@cartographerio/util";
const LadyFern = "LadyFern";
const OakFern = "OakFern";
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const NeRiverNaturalnessFernSpeciesEnum = {
    ...createEnum("NeRiverNaturalnessFernSpecies", [
        [LadyFern, "Lady fern (Athyrium filix-femina)"],
        [OakFern, "Oak fern (Gymnocarpium dryopteris)"],
    ]),
    LadyFern,
    OakFern,
};
null;
null;
export default NeRiverNaturalnessFernSpeciesEnum;
//# sourceMappingURL=NeRiverNaturalnessFernSpeciesEnum.generated.js.map